const middleware = {}

middleware['auth'] = require('../middleware/auth.js')
middleware['auth'] = middleware['auth'].default || middleware['auth']

middleware['basic-auth'] = require('../middleware/basic-auth.js')
middleware['basic-auth'] = middleware['basic-auth'].default || middleware['basic-auth']

middleware['redirect-to-folio'] = require('../middleware/redirect-to-folio.js')
middleware['redirect-to-folio'] = middleware['redirect-to-folio'].default || middleware['redirect-to-folio']

middleware['x-frame-options'] = require('../middleware/x-frame-options.js')
middleware['x-frame-options'] = middleware['x-frame-options'].default || middleware['x-frame-options']

export default middleware
